// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2WkDN","upload":"Small_upload__AWKjh","imageWrap":"Small_imageWrap__1Mm87","removeBtn":"Small_removeBtn__gPRIG"};